(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  const safePlay = (video) => {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.removeAttribute('controls');
    const result = video.play();
    if (result?.catch) result.catch(() => {});
  };

  ready(() => {
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const videos = [...document.querySelectorAll('.tb-brow video[data-tb-autoplay]')];

    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.loop = true;
      video.autoplay = true;
      video.removeAttribute('controls');
      video.addEventListener('loadeddata', () => {
        if (!reduceMotion) safePlay(video);
      }, { once: true });
      video.addEventListener('canplay', () => {
        if (!reduceMotion && video.paused) safePlay(video);
      });
    });

    if (!reduceMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) safePlay(video);
          else if (entry.intersectionRatio === 0) video.pause();
        });
      }, { rootMargin: '180px 0px', threshold: [0, .1] });
      videos.forEach((video) => observer.observe(video));
    } else if (!reduceMotion) {
      videos.forEach(safePlay);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden || reduceMotion) return;
      videos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        if (rect.bottom > -100 && rect.top < window.innerHeight + 100) safePlay(video);
      });
    });

    document.querySelectorAll('[data-tb-brow-product]').forEach((root) => {
      const buybox = root.querySelector('#tb-brow-buybox');
      const sticky = root.querySelector('[data-tb-brow-sticky]');
      const stickyButton = root.querySelector('[data-tb-brow-sticky-button]');
      const scrollBuy = root.querySelector('[data-tb-brow-scroll-buy]');
      const form = root.querySelector('form[data-type="add-to-cart-form"]');
      const quantity = form?.querySelector('input[name="quantity"]');
      const minus = form?.querySelector('[data-tb-brow-qty-minus]');
      const plus = form?.querySelector('[data-tb-brow-qty-plus]');

      minus?.addEventListener('click', () => {
        if (!quantity) return;
        const current = Number.parseInt(quantity.value || '1', 10);
        quantity.value = String(Math.max(1, current - 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus?.addEventListener('click', () => {
        if (!quantity) return;
        const current = Number.parseInt(quantity.value || '1', 10);
        quantity.value = String(Math.max(1, current + 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const scrollToBuybox = () => buybox?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      scrollBuy?.addEventListener('click', scrollToBuybox);
      stickyButton?.addEventListener('click', () => {
        const addButton = form?.querySelector('button[name="add"]');
        if (addButton && !addButton.disabled) addButton.click();
        else scrollToBuybox();
      });

      if (sticky && buybox) {
        const updateSticky = () => {
          const addButton = form?.querySelector('button[name="add"]');
          const referenceRect = addButton?.getBoundingClientRect() || buybox.getBoundingClientRect();
          const shouldShow = window.scrollY > 320 && referenceRect.bottom < 12;
          sticky.classList.toggle('is-visible', shouldShow);
        };
        updateSticky();
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
      }
    });
  });
})();
